import { create } from 'zustand';

interface PhotoCardMarketPopupStore {
  isBeforeReviewPopupOpen: boolean;
  setIsBeforeReviewPopupOpen: (isBeforeReviewPopupOpen: boolean) => void;
  isWriteReviewPopupOpen: boolean;
  setIsWriteReviewPopupOpen: (isWriteReviewPopupOpen: boolean) => void;
  selectedTradingPhotoCard: {
    tradingPhotoCardId: string;
    chatRoomId: string;
    traderUserProfileId: string;
    reviewableType: 'TradingPhotoCard' | 'MatchedTradingPhotoCard';
  } | null;
  setSelectedTradingPhotoCard: (
    selectedTradingPhotoCard: {
      tradingPhotoCardId: string;
      chatRoomId: string;
      traderUserProfileId: string;
      reviewableType: 'TradingPhotoCard' | 'MatchedTradingPhotoCard';
    } | null
  ) => void;
}

export const usePhotoCardMarketPopupStore = create<PhotoCardMarketPopupStore>((set) => ({
  isBeforeReviewPopupOpen: false,
  setIsBeforeReviewPopupOpen: (isBeforeReviewPopupOpen) => set({ isBeforeReviewPopupOpen }),
  isWriteReviewPopupOpen: false,
  setIsWriteReviewPopupOpen: (isWriteReviewPopupOpen) => set({ isWriteReviewPopupOpen }),
  selectedTradingPhotoCard: null,
  setSelectedTradingPhotoCard: (selectedTradingPhotoCard) => set({ selectedTradingPhotoCard })
}));
